/**
 * Shared editor-row shapes for the chart-config wizard. Numeric fields are held
 * as strings so inputs can be cleared; the shell parses them into the persisted
 * `ChartReferenceBand` / `ChartCutoffLine` shapes on save.
 */
export interface BandRow {
    label: string;
    min: string;
    max: string;
    color: string;
}

export interface CutoffRow {
    label: string;
    value: string;
    color: string;
}

export const toNumber = (value: string): number => (value.trim() === '' ? NaN : Number(value));

/**
 * Visual swatch defaults shown before the user picks a color. These mirror the
 * mirrored render core's `DEFAULT_BAND_COLOR` / `DEFAULT_CUTOFF_COLOR` intent
 * (chart-config.ts) but stay local because that file is byte-mirrored with the
 * backend and must not grow new exports.
 */
export const BAND_SWATCH_DEFAULT = '#3D52D9';
export const CUTOFF_SWATCH_DEFAULT = '#D6491F';
